<template>
    <div
        class="fixed inset-y-0 top-0 z-50 flex flex-col w-3/4 text-blue-500 bg-white drawer lg:w-1/2"
    >
        <button
            class="absolute top-0 right-0 mt-4 mr-5"
            aria-label="Close drawer"
            @click="$emit('close')"
        >
            <svg
                class="w-5 h-5 stroke-current text-grey-200"
                role="img"
                focusable="false"
                aria-label=""
                viewBox="0 0 20 20"
            >
                <path
                    d="M10.707 10.5l5.646-5.646a.5.5 0 00-.707-.707L10 9.793 4.354 4.147a.5.5 0 00-.707.707L9.293 10.5l-5.646 5.646a.5.5 0 00.708.707l5.646-5.646 5.646 5.646a.498.498 0 00.708 0 .5.5 0 000-.707L10.709 10.5z"
                />
            </svg>
        </button>

        <h2 class="px-5 pt-20 pb-4 border-b border-blue-100 h2">Filters</h2>

        <div class="flex-1 p-5 pt-8 overflow-y-auto">
            <p class="font-semibold">Services</p>

            <ais-refinement-list
                v-slot="{ items, refine }"
                :transform-items="alphabetise"
                attribute="services"
            >
                <BaseCheckbox
                    v-for="item in items"
                    :key="item.value"
                    class="my-5"
                    :label="item.label"
                    :value="item.value"
                    :selected="item.isRefined"
                    @checked="refine(item.value)"
                />
            </ais-refinement-list>

            <p class="mt-8 mb-5 font-semibold">Opening Hours</p>
            <ais-toggle-refinement
                v-slot="{ value, refine }"
                attribute="openSaturdays"
                label="Open Saturdays"
            >
                <BaseCheckbox
                    class="mb-4"
                    label="Open Saturdays"
                    value="Open Saturdays"
                    :selected="value.isRefined"
                    @checked="
                        refine(value);
                        trackRefinment('Open Hours', value, value.isRefined);
                    "
                />
            </ais-toggle-refinement>
            <ais-toggle-refinement
                v-slot="{ value, refine }"
                attribute="openSundays"
                label="Open Sundays"
            >
                <BaseCheckbox
                    class="mb-4"
                    label="Open Sundays"
                    value="Open Sundays"
                    :selected="value.isRefined"
                    @checked="
                        refine(value);
                        trackRefinment('Open Hours', value, value.isRefined);
                    "
                />
            </ais-toggle-refinement>
            <ais-toggle-refinement
                v-slot="{ value, refine }"
                attribute="openAfter5pm"
                label="Open after 5pm"
            >
                <BaseCheckbox
                    class="mb-4"
                    label="Open after 5pm"
                    value="Open after 5pm"
                    :selected="value.isRefined"
                    @checked="
                        refine(value);
                        trackRefinment('Open Hours', value, value.isRefined);
                    "
                />
            </ais-toggle-refinement>
            <ais-toggle-refinement
                v-slot="{ value, refine }"
                attribute="openBefore9am"
                label="Open before 9am"
            >
                <BaseCheckbox
                    class="mb-4"
                    label="Open before 9am"
                    value="Open before 9am"
                    :selected="value.isRefined"
                    @checked="
                        refine(value);
                        trackRefinment('Open Hours', value, value.isRefined);
                    "
                />
            </ais-toggle-refinement>

            <p class="mt-8 font-semibold">Payment</p>

            <ais-refinement-list
                v-slot="{ items, refine }"
                :transform-items="alphabetise"
                attribute="payments"
            >
                <BaseCheckbox
                    v-for="item in items"
                    :key="item.value"
                    class="my-5"
                    :label="item.label"
                    :value="item.value"
                    :selected="item.isRefined"
                    @checked="refine(item.value)"
                />
            </ais-refinement-list>
        </div>

        <button class="m-5 btn" @click="$emit('close')">Apply</button>
    </div>
</template>

<script>
import sortBy from 'lodash/sortBy';

export default {
    methods: {
        alphabetise(items) {
            return sortBy(items, ['label']);
        }
    }
};
</script>
